import { Link } from '@customink/pigment-react';

import { LOGIN_URL } from '@/constants';

export function LoginLink({ children = 'log in' }) {
  return (
    <Link data-testid="login-link" href={LOGIN_URL}>
      {children}
    </Link>
  );
}
